import styled from "@emotion/styled";

export const TitleStyled = styled.h1`
  font-size: 32px;
  font-weight: 600;
  line-height: 1.05;
  margin-bottom: 20px;
  margin-top: 0;

  text-align: center;
  color: ${({ theme }) => theme.colors.white};

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    font-size: 88px;
    margin-bottom: 32px;
  }
`;
